import { z } from 'zod'

export const SocialTypeEnumSchema = z.enum(['kakao', 'google', 'naver'])

export type SocialTypeEnum = z.infer<typeof SocialTypeEnumSchema>
